import React from 'react';
import styled from 'styled-components';

export const ProductDescription = ({ description, showMoreInformation, textLink }) => (
  <WrapperProductDescription>
    {description && <Description>{description}</Description>}
    {showMoreInformation && <LinkSeeMoreInformation href="#info-section">{textLink}</LinkSeeMoreInformation>}
  </WrapperProductDescription>
);

const WrapperProductDescription = styled.div`
  display: flex;
  flex-direction: column;
`;

const Description = styled.p`
  padding-top: 20px;
  font-size: ${({ theme }) => theme.fontSize.xs};
  word-break: break-word;
`;

const LinkSeeMoreInformation = styled.a`
  margin-top: 20px;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  text-transform: ${({ theme }) => theme.titleTransform};

  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export default ProductDescription;
